<template>
  <v-dialog :value="show" persistent max-width="480">
    <v-card>
      <v-card-title class="text-h5"> Ajout </v-card-title>
      <v-card-text>
        Indiquez le document à ajouter au produit ainsi que son type et
        éventuellement son contenu.
        <v-file-input
          v-model="fichier"
          label="Fichier PDF"
          accept="application/pdf"
          required
          :error-messages="fichierErrors"
          show-size
          @input="$v.fichier.$touch()"
          @blur="$v.fichier.$touch()"
        ></v-file-input>
        <v-select
          label="Type"
          v-model="typeDocument"
          :items="types"
          hint="Type de document, selon la nomenclature Euro-Pharmat."
          clearable
          :error-messages="typeErrors"
          @input="$v.typeDocument.$touch()"
          @blur="$v.typeDocument.$touch()"
        ></v-select>
        <v-text-field
          label="Contenu"
          v-model="intitule"
          hint="Description du contenu ou information annexe au sujet du document."
          counter="80"
          clearable
          :error-messages="contenuErrors"
          @input="$v.intitule.$touch()"
          @blur="$v.intitule.$touch()"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" text @click="validate" :disabled="!valid">
          OK
        </v-btn>
        <v-btn color="error" text @click="$emit('cancel')"> Annuler </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { maxFileSize } from "@/validators/validators";
import { required, requiredIf, maxLength } from "vuelidate/lib/validators";

export default {
  name: "ProduitDocumentDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    // editedImage: {
    //   type: Object,
    //   default: null,
    // },
  },
  data() {
    return {
      fichier: null,
      typeDocument: "Autre",
      intitule: null,
      types: [
        "Fiche technique",
        "Manuel ou notice d'utilisation",
        "Certificat marquage CE",
        "Carte d'implant",
        "Bibliographie",
        "Autre",
      ],
    };
  },
  watch: {
    show() {
      //   if (this.editedImage != null) {
      //     this.fichier = this.editedImage.fichier;
      //     this.description = this.editedImage.description;
      //   } else {
      this.fichier = null;
      this.typeDocument = "Autre";
      this.intitule = null;
      this.$v.$reset();
      //   }
    },
  },
  computed: {
    valid() {
      return !this.$v.$invalid;
    },
    fichierErrors() {
      const errors = [];
      if (!this.$v.fichier.$dirty) return errors;
      !this.$v.fichier.required && errors.push("Obligatoire");
      !this.$v.fichier.maxFileSize && errors.push("Taille maximum: 10 Mo");
      return errors;
    },
    typeErrors() {
      const errors = [];
      if (!this.$v.typeDocument.$dirty) return errors;
      !this.$v.typeDocument.required && errors.push("Obligatoire");
      return errors;
    },
    contenuErrors() {
      const errors = [];
      if (!this.$v.intitule.$dirty) return errors;
      !this.$v.intitule.required &&
        errors.push("Obligatoire lorque le type est 'Autre'");
      !this.$v.intitule.maxLength && errors.push("80 caractères au maximum");
      return errors;
    },
  },
  methods: {
    validate() {
      let doc = {
        fichier: this.fichier.name,
        typeDocument: this.typeDocument,
        intitule: this.intitule,
        local: true,
        fileCtl: this.fichier,
      };

      console.log("documents fileCtl", this.fichier);
      console.log("PDD doc.fileCtl", doc.fileCtl);

      this.$emit("ok", doc);
    },
  },
  validations: {
    fichier: {
      required,
      maxFileSize: maxFileSize(10500000), //10Mb
    },
    typeDocument: {
      required,
    },
    intitule: {
      required: requiredIf((nm) => nm.typeDocument === "Autre"),
      maxLength: maxLength(80),
    },
  },
};
</script>

<style></style>
